import styled from "styled-components";

export const ControlsWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  padding-right: 2px;
`;
